export const IconsList = [
  'attention',
  'clipboard',
  'clock',
  'credit-card',
  'document',
  'eye',
  'menu',
  'close',
  'chevron-down',
  'chevron-up',
  'chevron-left',
  'chevron-right',
  'chevron-double-left',
  'chevron-double-right',
  'chevron-bar-left',
  'chevron-bar-right',
  'home',
  'users',
  'orders',
  'client-apps',
  'search',
  'code',
  'refund',
  'refresh',
  'void',
  'pencil',
  'trash',
  'plus',
];
